import { FC } from "react";
import clsx from "clsx";
import { BaseIconProps } from "@/shared/icons/BaseIcon";

type Props = {
  progress: number;
  icon: FC<BaseIconProps>;
  size: number;
  className?: string;
};

export default function InventoryCharacterProgressIcon({ icon, progress, size, className }: Props) {
  return (
    <div className={clsx("relative size-5", className)}>
      {icon({ size, className: "absolute opacity-30" })}
      {icon({
        size,
        className: "absolute",
        style: {
          clipPath: `polygon(0 ${100 - progress}%, 100% ${100 - progress}%, 100% 100%, 0 100%)`,
        },
      })}
    </div>
  );
}
